/* Pouches sets (sections/pouch-sets.liquid): add one set to the cart and open the Rebuy drawer.
   The buttons are type="button" with no <form> around them, so Rebuy's form hook can't fire a
   second add alongside this one (the double-add the old bundle blocks suffered from).
   One delegated listener covers every copy of the section, including theme-editor re-renders. */
(function () {
  if (window.__pouchSetsBound) return;
  window.__pouchSetsBound = true;

  /* same ladder as quit-kit.js / ripple-air-singles.js: theme drawer first, then fall back */
  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    try {
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
        window.Rebuy.SmartCart.show();
        return;
      }
    } catch (e) {}
    var link = document.querySelector('a.cart-link, [data-cart-toggle], [data-cart-drawer-toggle], .js-cart-trigger, .js-drawer-open-cart');
    if (link) { link.click(); return; }
    window.location.href = '/cart';
  }

  function say(el, text) {
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  function soldOut(btn, label) {
    btn.disabled = true;
    btn.removeAttribute('data-pbs-variant');
    btn.textContent = label || 'Sold out';
  }

  function add(btn) {
    var id = btn.getAttribute('data-pbs-variant');
    if (!id || btn.disabled || btn.classList.contains('is-loading')) return;
    var root = btn.closest('[data-pbs]');
    var msg = btn.parentNode.querySelector('[data-pbs-msg]');
    var errText = (root && root.getAttribute('data-pbs-error')) || 'Something went wrong. Please try again.';
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    say(msg, '');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    function done() { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }

    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      /* an edge or rate-limit error can answer with HTML - don't let that throw */
      return r.json().catch(function () { return {}; }).then(function (body) { return { ok: r.ok, body: body }; });
    }).then(function (res) {
      done();
      if (res.ok) { openCart(); return; }
      /* stay on the page and say why, rather than bouncing to /cart (which forwards home) */
      var why = res.body && (res.body.description || res.body.message);
      if (why && /sold out/i.test(why)) soldOut(btn, root && root.getAttribute('data-pbs-sold-out'));
      say(msg, why || errText);
    }).catch(function () {
      done();
      say(msg, errText);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.pbs__btn') : null;
    if (!btn || !btn.closest('[data-pbs]')) return;
    e.preventDefault();
    add(btn);
  });
})();
